import React, { memo } from 'react';
import BottomNavigationSlot from '../BottomNavigationSlot';
import { BottomNavigationItem } from '../types';
import styles from '../BottomNavigation.module.scss';

interface ItemLinkProps {
  item: BottomNavigationItem;
  index: number;
}

const ItemLink: React.FC<ItemLinkProps> = memo(({ item, index }) => (
  <div className={styles.slot} key={index} data-testid="slot">
    <a
      className={styles.link}
      href={item.url || ''}
      target={item.target || ''}
      rel="noopener noreferrer"
    >
      <BottomNavigationSlot item={item} />
    </a>
  </div>
));

export default ItemLink;
